import { Navigation, Pagination } from 'swiper';
import { SwiperSlide } from 'swiper/react';

import { Field, Text, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps } from 'lib/ComponentProps';

import { ExtendedItem } from 'src/types/ExtendedItem';

import { SwiperComponent } from '../_Swiper/SwiperComponent';

import styles from './TextCarousel.module.css';

type TextCarouselProps = ComponentProps & {
	fields: {
		Title: Field<string>;
		items: ExtendedItem &
			[
				{
					fields: {
						Text: Field<string>;
						SupportingText: Field<string>;
					};
				}
			];
	};
};

export default withDatasourceCheck()<TextCarouselProps>(Carousel);

function Carousel(props: TextCarouselProps): JSX.Element {
	return (
		<section className="cen padX padYL maxWidth" aria-label="Gallery">
			<Text tag="h2" field={props.fields.Title} />

			{props.fields.items && props.fields.items.length > 1 && (
				<SwiperComponent
					modules={[Navigation, Pagination]}
					pagination={{
						clickable: true,
					}}
					navigation
					autoHeight={true}
					className={styles.slider}
				>
					{props.fields.items.map((slide, index) => (
						<SwiperSlide key={`${props.rendering.dataSource}-${index}`}>
							<Text tag="p" field={slide.fields.Text} className={styles.quote} />
							<Text tag="h5" field={slide.fields.SupportingText} className={styles.quotee} />
						</SwiperSlide>
					))}
				</SwiperComponent>
			)}

			{props.fields.items && props.fields.items.length === 1 && (
				<div className={styles.slider}>
					<Text tag="p" field={props.fields.items[0].fields.Text} className={styles.quote} />
					<Text tag="h5" field={props.fields.items[0].fields.SupportingText} className={styles.quotee} />
				</div>
			)}
		</section>
	);
}
